import { BaseError } from './base';

export class MissingSocialUrlParamError extends BaseError {
  constructor(param: string) {
    super({
      cause: null,
      code: 'missing_social_url_param_error',
      docsUrl: null,
      name: 'MissingSocialParamError',
      shortMessage: `To complete social sign in, the following URL query parameter is required to be set but was not found: ${param}`,
    });
  }
}
